import React from 'react';
import FeaturedSVG from '../assets/FeaturedLogo.svg'; // Adjust the path as needed
import { Box, Grid } from '@mui/material';
import RelianceLogo from "../assets/RelianceLogo.webp";
import DdevPlastics from "../assets/DdevPlastics.webp";
import PrincePipeSystems from "../assets/PrincePipeSystems.webp";
import WelspunLiving from "../assets/WelspunLiving.webp";

import Wockhardt from "../assets/Wockhardt.webp";
import IpcaLab from "../assets/IpcaLab.webp";
import CalibreChem from "../assets/CalibreChem.webp";
import AlokIndustries from "../assets/AlokIndustries.webp";
import KeiCables from "../assets/KeiCables.webp";


const ImageGrid = ({ images }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Grid container spacing={2} justifyContent="center" alignItems="center" maxWidth={1000}>
        {images.map((image, index) => (
          <Grid item xs={4} key={index}>
            <Box
              component="img"
              src={image}
              alt={`image-${index}`}
              sx={{
                width: '100%',
                height: 'auto',
                display: 'block',
                maxWidth: '200px', // Adjust as per your needs
                maxHeight: '200px',
                margin: '0 auto',
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};


const Clients = () => {

  const images = [
    RelianceLogo,
    DdevPlastics,
    WelspunLiving,
    PrincePipeSystems,
    Wockhardt,
    CalibreChem,
    AlokIndustries,
    IpcaLab,
    KeiCables
  ];

  return (
    <div style={{ textAlign: 'center', padding: '2px', position: 'relative' }}>
      <img src={FeaturedSVG} alt="Featured SVG" style={{ width: '100%', height: 'auto' }} />
      <h3 style={{
        color: '#B1B1B1',
        fontFamily: 'Inter, sans-serif',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
        marginTop: '10px'
      }}>
        OUR CLIENTS
      </h3>
      <ImageGrid images={images} />
    </div>
  );
};

export default Clients;
